import { render, staticRenderFns } from "./TestingSingleCourse.vue?vue&type=template&id=6b7b8e62&scoped=true"
import script from "./TestingSingleCourse.vue?vue&type=script&lang=js"
export * from "./TestingSingleCourse.vue?vue&type=script&lang=js"
import style0 from "./TestingSingleCourse.vue?vue&type=style&index=0&id=6b7b8e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b8e62",
  null
  
)

export default component.exports